import { connect } from 'react-redux';
import EventShowView from './index'
import {showEvent, clearEvent} from '../../actions/Events'

const mapStateToProps = (state, props) => {
    
    return {
	event: state.events.current
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	showEvent: (id) => {
	    return dispatch(showEvent(id));
	},
	clearEvent: () => {
	    return dispatch(clearEvent());
	}
    }
}

const EventShowContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EventShowView);




export default EventShowContainer;



// WEBPACK FOOTER //
// ./src/components/EventShow/Container.js